import missingImg from '@/site/assets/launcher-icon-4x.png'
import type { Product } from '@/site/lib/types'

const price = (p: Product['price']) => {
  const n = typeof p === 'number' ? p : parseFloat(String(p))
  return Number.isFinite(n) && n > 0 ? `$${n.toFixed(2)}` : ''
}

/** Products from the tutorial, linking to the Missouri Star shop. */
export default function TutorialProducts({ products }: { products: Product[] }) {
  return (
    <section aria-labelledby="products" className="flex flex-col gap-5">
      <h2 id="products" className="text-2xl font-extrabold md:text-[28px]">
        Shop this tutorial
      </h2>
      <ul className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
        {products.map((p, i) => (
          <li key={p.id ?? i}>
            <a href={p.url} target="_blank" rel="noreferrer" className="group flex h-full flex-col gap-2 rounded-2xl border-2 border-qt-line p-3 hover:border-qt-stitch">
              <img
                loading="lazy"
                src={p.thumbnail?.replace('images/thumbnail', 'images/product') || missingImg}
                alt=""
                width="300"
                height="300"
                className="aspect-square w-full rounded-xl bg-qt-soft object-cover"
                onError={(e) => {
                  e.currentTarget.src = missingImg
                }}
              />
              <span className="line-clamp-3 text-sm leading-snug font-bold group-hover:underline">{p.title}</span>
              <span className="mt-auto flex items-baseline justify-between text-sm font-bold">
                <span>{price(p.price)}</span>
                <span className="text-qt-primary">Shop →</span>
              </span>
            </a>
          </li>
        ))}
      </ul>
    </section>
  )
}
